export const EXAMPLE_CHATS = [
	"SUVs in today's sale sorted by distance from me, nearest first.",
	'List hatchbacks under £15,000 with full service history and include the exterior colour for each.',
	'Automatic diesel estates with one or two previous owners, ordered by proximity.',
	'Saloons with full service history sitting at condition grade 1 or 2.',
	'Convertibles under £20,000 with mileage below 70,000 miles.',
	'Seven-seat vehicles under £18,000 within 100 miles of me.',
	'City cars with a single owner and genuinely low mileage for their age.',
	'Premium SUVs featuring leather interiors and automatic transmission.',
	"Coupes in today's live sale, ranked by lowest mileage first.",
	'Electric SUVs equipped with a parking camera and heated seats.',
	'Vehicles listed in and around Leeds with full service history.',
	'Cars in the South East region priced under £20,000.',
	'Manchester sellers offering automatics with mileage below 40k.',
	'West Yorkshire vehicles at grade 1 or 2 with a full service history.',
	'Reading-based listings under £15,000.',
	'Local sellers within 50 miles ranked by closest first.',
	'Anything near me fitted with a panoramic roof.',
	'Glasgow vehicles with mileage under 60000',
	'Diesel estates under £16,000',
	'One-owner cars with full history located near Wolverhampton.',
	'Land Rovers priced below CAP within 50 miles of Birmingham.',
	'Cars under £18,000 with both a reversing camera and parking sensors.',
	'Automatics with Apple CarPlay, nearest first.',
	'Vehicles featuring a panoramic roof alongside full service history.',
	'Diesel SUVs equipped with sat nav and cruise control.',
	'Petrol hatchbacks with heated seats and mileage under 50k.',
	'Vehicles listing adaptive headlights in their spec.',
	'Cars fitted with a tow bar.',
	'EVs supporting rapid charging.',
	'Leather-seat cars at a premium price point.',
	'Vehicles with a digital cockpit or digital instrument cluster mentioned in features.',
	'Live cars with no mechanical or electrical problems and no tyre issues, sorted by lowest mileage.',
	'Vehicles with zero dashboard warning lights alongside full service history.',
	'One-owner cars with clean alloys and no reported tyre concerns.',
	'Vehicles explicitly flagged as never smoked in.',
	'Grade 1 or 2 vehicles carrying no active condition flags.',
	'Vehicles under £15,000 with no dashboard warnings, no tyre problems, and no mechanical flags.',
	"Lowest-prep-risk vehicles in today's sale based on damage flags.",
	'Cars supplied with two keys and a full service history.',
	'Cars with two keys, a single owner, and mileage under 40k.',
	'Automatics under £20,000 that come with both keys.',
	'SUVs with a complete key set and no warning lights on the dashboard.',
	'Hatchbacks with two keys and a clean condition grade.',
	'Petrol cars with two keys sitting at grade 1 or 2.',
	'Low-mileage diesels supplied with both keys and service history.',
	'Vehicles with two keys ranked by nearest first.',
	'Budget cars under £8,000 that still include both keys.',
	'Audi models broken down by specific trim — not just the model range.',
	'BMW M Sport examples under £22,000 with mileage below 60k.',
	'Mercedes AMG Line cars with full service history and an automatic gearbox.',
	'Volkswagen R-Line vehicles within 120 miles.',
	'Ford ST-Line trims ordered by nearest first.',
	'Toyota hybrids on higher trim grades with fewer than two keepers.',
	'Volvo cars on the top-tier trim lines.',
	'Land Rover HSE examples with mileage below 90,000.',
	"Nissan Tekna-spec cars in today's live sale.",
	'Kia GT-Line trims with a documented full service history.',
	'SUVs with engines over 2.0 litres paired with an automatic gearbox.',
	'Petrol hatchbacks with engines of 1.2 litres or smaller.',
	'Diesel estates with engines between 1.8 and 2.2 litres and one or two keepers.',
	'Hybrids with engines under 1.8 litres and mileage below 50k.',
	'Saloons with engines above 2.0 litres sitting at grade 1 or 2.',
	'Five-door cars with mileage under 60,000.',
	'Seven-seat vehicles suitable for larger households.',
	'Compact crossovers with five seats and mileage under 40,000.',
	'MPVs and SUVs carrying seven or more seats.',
	'Three-door hatchbacks under £12,000.',
	'Hybrid hatchbacks, sort by distance closest to me, never been smoked in',
	'Vehicles with one keeper held for over three years plus full service records.',
	'SUVs whose ownership has been stable for multiple years.',
	'Hatchbacks with a current keeper tenure exceeding two years.',
	'Cars combining long keeper tenure with a full service history.',
	'Late-plate cars (2022 onwards) with a single long-tenure keeper.',
	'Automatics from 2021 or newer where keeper history supports retail confidence.',
	'Low-mileage cars with stable ownership since first registration.',
	'Cars with a private plate, and flag whether the plate stays with the vehicle.',
	'Private-plate vehicles under £25,000 with full service history.',
	'One-owner vehicles carrying a private plate and mileage under 40k.',
	'Hatchbacks on private plates, ranked by closest first.',
	'Private-plate vehicles including two keys and no dashboard warning lights.',
	"All private-plate vehicles in today's sale with a clear plate-retention status.",
	'Cars in black or dark grey with mileage under 50,000.',
	'White SUVs with full service history and mileage below 60,000.',
	'Vehicles with a black leather interior at grade 1 or 2.',
	'Vehicles under three years old',
	'Automatics under £18,000 showing no condition flags, a single owner, and two keys',
] as const;

export type ExampleChat = (typeof EXAMPLE_CHATS)[number];
